<template src='./VerListadoEncuentros.html'></template>
<script>
import VerListadoCategorias from "../VerListadoCategorias/VerListadoCategorias";
import { listaEncuentrosPorPaciente } from "../../apiService/request/CrudEncuentro";
import { consultarInformacionMomentosEncuentro } from "../../apiService/request/CrudEncuentro";
import { resumenEncuentrosPorTipo } from "../../apiService/request/CrudEncuentro";
import { serverBus } from "../../main";
export default {
  data() {
    return {
      formulariosMomentosllenos: [],
      formulariosLlenosTipoMomento: [],
      banderaOcultarMas: true
    };
  },
  created() {
    this.consultarListaEncuentros();
  },
  mounted() {
    // serverBus.$on("volver", ()=> {
    //   this.consultarListaEncuentros()
    // });
    serverBus.$on("verCategoriaFormularioOverlay",(nombreCategoria, coleccion)=> {
      this.formulariosLlenosTipoMomento = [];
      this.consultarResumenEncuentrosPorTipo(nombreCategoria, coleccion);
      // this.$store.dispatch("setMensajeChatBox", nombreCategoria);
    });
  },
  beforeDestroy() {
    serverBus.$off("verCategoriaFormularioOverlay");
  },
  computed: {
    getConsultarEncuentro() {
      if (this.$store.getters.getConsultarEncuentro != null) {
        this.consultarResumenEncuentrosPorTipo(
          this.$store.getters.getConsultarEncuentro,
        );
      }
      return this.$store.getters.getConsultarEncuentro;
    }
  },
  watch: {
    // getReiniciar(){},
    // getConsultarEncuentro() {}
  },
  components: {
    VerListadoCategorias
  },
  methods: {
    async consultarListaEncuentros() {
      try {
        this.$store.dispatch('setCargando', true);
        const respuesta = await listaEncuentrosPorPaciente(
          this.$store.getters.getCedulaPaciente
        );
        this.formulariosMomentosllenos = respuesta.data.data;
      } catch (err) {
      }finally{
        this.$store.dispatch('setCargando', false);
      }
    },
    async consultarResumenEncuentrosPorTipo(nombre_form, coleccion) {
        try{
          this.$store.dispatch("setCargando", true);
          const respuesta = await resumenEncuentrosPorTipo(
            this.$store.getters.getCedulaPaciente,
            nombre_form,
            coleccion
          );
          if (respuesta.data && respuesta.data.data) {
            this.formulariosLlenosTipoMomento = respuesta.data.data;
          }
        } catch (err) {
          console.log('error: ListadoEncuentors');
          console.log(err);
        } finally {
          this.$store.dispatch("setCargando", false);
        }
    }
  }
};
</script>
<style src='./VerListadoEncuentros.css' lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/VerListadoEncuentros/VerListadoEncuentros.vue